import BackgroundElements from '../components/BackgroundElements';
import LoginForm from '../components/LoginForm';
import Logo from '../components/Logo';
import Footer from '../components/Footer';


const LoginPage = () => {

  const handleLoginSuccess = (email: string) => {

    console.log(`Authentication in progress for ${email}`);
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-[#fff5eb] to-[#f9f6f4] flex items-center justify-center px-4 relative overflow-hidden">
      <BackgroundElements />
      
      {/* Logo in top-left corner */}
      <div className="absolute top-6 left-6 z-20">
        <Logo size="md" />
      </div>

      <div className="w-full max-w-md flex items-center justify-center z-10">
        <div className="w-full">
          <div className="relative">
            {/* Decorative elements */}
            <div className="-z-10 absolute -top-5 -left-5 w-20 h-20 bg-[#ff8c42]/5 rounded-full"></div>
            <div className="-z-10 absolute -bottom-8 -right-8 w-28 h-28 bg-[#ff6b6b]/5 rounded-full"></div>
            
            <LoginForm onSuccess={handleLoginSuccess} />
          </div>
          
          <Footer className="mt-8" />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;